import { Flex } from '@mantine/core';
import { useMemo } from 'react';
import { useFeatureFlag } from '../../../helpers/feature-flags/feature-flags.hooks';
import { FeatureFlag } from '../../../helpers/feature-flags/feature-flags.type';
import { useProcessAnalysisStore } from '../../../store/process-analysis-store/process-analysis-store';
import { setActiveTab } from '../../../store/process-analysis-store/process-analysis-store.actions';
import { baseWhite, inkLight } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';
import { Tab } from '../process-analysis.type';
import { tabs, type TabEntry } from './tabs.data';

export const Tabs = () => {
  const activeTab = useProcessAnalysisStore((state) => state.activeTab);
  const isAgenticProcessEnabled = useFeatureFlag(FeatureFlag.AgenticProcessByHooks);

  const visibleTabs = useMemo<TabEntry[]>(
    () => (isAgenticProcessEnabled ? [...tabs, { id: Tab.Agents, textKey: 'common.agents', icon: 'smart_toy' }] : tabs),
    [isAgenticProcessEnabled],
  );

  return (
    <Flex gap={8} style={{ overflowX: 'auto' }}>
      {visibleTabs.map((tab) => (
        <Button
          key={tab.id}
          radius="xl"
          size="xs"
          variant={activeTab === tab.id ? 'secondary' : 'outline'}
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => setActiveTab(tab.id)}
          leftSection={<Icon name={tab.icon} size={14} color={activeTab === tab.id ? baseWhite : inkLight} pointer />}
        >
          <Text size="small" textKey={tab.textKey}>
            {tab.textKey}
          </Text>
        </Button>
      ))}
    </Flex>
  );
};
